import React from "react";
import { View, TextInput, Dimensions } from "react-native";
import { StyleSheet } from "react-native";

import defaultStyles from "../config/styles";

function AppTextInput({ icon, textStyle, style, ...otherProps }) {
  return (
    <View style={[styles.container, textStyle]}>
      {/* {icon && (
        <MaterialCommunityIcons
          name={icon}
          size={30}
          color={defaultStyles.colors.medium}
          style={styles.icon}
        />
      )} */}
      <TextInput
        placeholderTextColor={defaultStyles.colors.dark}
        style={[defaultStyles.text, styles.input]}
        {...otherProps}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: defaultStyles.colors.inputBackground,
    borderRadius: 8, //25
    flexDirection: "row",
    width:
      window.innerWidth <= 760
        ? 0.8 * Dimensions.get("window").width
        : 0.3 * Dimensions.get("window").width,
    height: 50,
    // padding: 15,
    // paddingLeft: 15,
    // marginVertical: 10,
    alignItems: "center",
    overflow: "hidden",
  },
  icon: {
    marginRight: 10,
  },
  input: {
    width:
      window.innerWidth <= 760
        ? 0.8 * Dimensions.get("window").width
        : 0.3 * Dimensions.get("window").width,
    height: "100%",
    paddingRight: 30,
    paddingLeft: 15,
  },
});

export default AppTextInput;
